var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsBarMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D2DCE2",
    d: "M0.997 0.328H28.986V29.596999999999998H0.997z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.907 10.39c-.435 0-.787-.41-.787-.915 0-.505.352-.915.787-.915h14.17c.435 0 .787.41.787.915 0 .505-.352.915-.787.915H7.907zm0 5.488c-.435 0-.787-.41-.787-.915 0-.505.352-.915.787-.915h14.17c.435 0 .787.41.787.915 0 .505-.352.915-.787.915H7.907zM7.12 20.45c0 .505.352.915.787.915h14.17c.435 0 .787-.41.787-.915 0-.505-.352-.915-.787-.915H7.907c-.435 0-.787.41-.787.915z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBarMenu);
export default __webpack_public_path__ + "static/media/icons-bar-menu.ee343ad4987badd7b67a2d91a9083ac1.svg";
export { ForwardRef as ReactComponent };